import axios from 'axios';
import apiConfig from '../api.config';

export default function paymentsExportRequest({ hotel, dateFrom, dateTo, lang }) {
  const {
    host,
    URIs: { purchasesExport },
  } = apiConfig;

  var filter = { dateFrom, dateTo };
  if (hotel) filter.hotel = hotel;

  const uri = `${host}${purchasesExport}?filter=${JSON.stringify(filter)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        lang,
      },
      responseType: 'arraybuffer',
    })
    .then(res => {
      return res.data;
    });
}
